import { useQuery } from "@tanstack/react-query";
import { queryLinks } from "../../utils/firebase";

export function useLinksList() {
	return useQuery({
		queryKey: ["links", "list"],
		async queryFn() {
			const data = await queryLinks();
			return data;
		},
	});
}
